import React from 'react';
import {Toaster} from "react-hot-toast";
import Builder from "./components/Builder/Builder";
import DeveloperProvider from "./providers/DeveloperProvider/DeveloperProvider";
import RequestsProvider from "./providers/RequestsProvider/RequestsProvider";
import StoreProvider from "./providers/StoreProvider/StoreProvider";
import {Global} from "./styles/global";
import './App-external';


import 'react-loading-skeleton/dist/skeleton.css';


const App: React.FC = () => {
    return (
        <RequestsProvider>
            <Global/>

            <StoreProvider>
                <Builder/>

                <Toaster position="bottom-left" toastOptions={{duration: 5000}}/>

                <DeveloperProvider/>
            </StoreProvider>

        </RequestsProvider>
    );
}

export default App;
